export const FB_PIXEL_ID = "4203258246371231";
export const COOPERATION_DIALOG_HASH = "#cooperation";
export const RATE_SMILE_DIALOG_HASH = "#rate-smile";
export const ACCEPT_COOKIES_KEY = "eb-cookies-accepted";
